import React from 'react'
import Icon from 'react-icon-base'

export default props => {
  return (
    <Icon viewBox="0 0 13 8" {...props}>
      <title>{props.title || 'Chevron Up'}</title>
      <g>
        <g stroke="none" strokeWidth="1" fillRule="evenodd" fill="none">
          <g
            transform="translate(1.000000, 2.000000)"
            strokeWidth="2"
            stroke="currentColor"
          >
            <polyline
              transform="translate(5.500000, 2.500000) rotate(90.000000) translate(-5.500000, -2.500000) "
              points="8 -2.5 3 2.5 8 7.5"
            />
          </g>
        </g>
      </g>
    </Icon>
  )
}
